export default "__VITE_PUBLIC_ASSET__d0e77b90__"